import type { InventoryResource } from "@@/shared/acquire/resources/inventory-resource";
import type { ResourceAccommodation } from "@@/shared/acquire/resources/resource-accommodation/resource-accommodation";
import { resourceGenericZodObject } from "@@/shared/acquire/resources/resource-generic";
import { resourceReservedZodObject } from "@@/shared/acquire/resources/resource-reserved";
import { resourceTableZodObject } from "@@/shared/acquire/resources/resource-table";
import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import type { ZodSchema} from "zod";
import { z } from "zod";

type ResourceEditCommandResponse = {
    readonly _id: string;
    readonly _type: "RESOURCE_EDIT_COMMAND_RESPONSE";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly resource: Exclude<InventoryResource, ResourceAccommodation>;
};

type FactoryParams = Except<
    ResourceEditCommandResponse,
    "_id" | "_type" | "_createdAt"
>;
const resourceEditCommandResponseFactory = (params: FactoryParams) => {
    const ResourceEditCommandResponse: ResourceEditCommandResponse = {
        ...params,
        _id: generateId({ prefix: "resource_edit_command__" }),
        _type: "RESOURCE_EDIT_COMMAND_RESPONSE",
        _createdAt: nowIsoAndUnix(),
    };
    return ResourceEditCommandResponse;
};

const resourceEditCommandResponseZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("RESOURCE_EDIT_COMMAND_RESPONSE"),
    _createdAt: isoAndUnixZodSchema,
    resource: z.union([
        resourceGenericZodObject,
        resourceReservedZodObject,
        resourceTableZodObject,
    ]),
}) satisfies ZodSchema<ResourceEditCommandResponse>;

const resourceEditCommandResponseFactoryParamsZodObject =
    resourceEditCommandResponseZodSchema.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });

export {
    resourceEditCommandResponseFactory,
    resourceEditCommandResponseFactoryParamsZodObject,
    resourceEditCommandResponseZodSchema,
};
export type {
    ResourceEditCommandResponse,
    FactoryParams as ResourceEditCommandResponseFactoryParams,
};
